import React from 'react';
import { CheckIcon, FlameIcon, GlobeIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { Countdown } from './Countdown';
import { images, valueStack } from '../data/content';
const SPOTS_LEFT = 7;
const CLAIMED_PERCENT = 93;
export function Offer() {
  const total = valueStack.reduce((sum, item) => sum + item.value, 0);
  return <section id="offer" className="bg-navy px-3 py-16 sm:px-5 sm:py-20" aria-labelledby="offer-title" data-id="element-154" data-mp="1hqs5641b9fih">
      <div className="mx-auto max-w-2xl" data-id="element-155" data-mp="u0obophu6w57">
        <div className="px-2 text-center text-white" data-id="element-156" data-mp="p0tn4sljainb">
          <h2 id="offer-title" className="text-[28px] font-black leading-tight tracking-tight sm:text-4xl" data-id="element-157" data-mp="p24qirb2hodw">
            GET THE COMPLETE AAC CLINICAL BLUEPRINT™ COLLECTION
          </h2>
          <p className="mt-4 text-[17px] leading-relaxed text-white/80" data-id="element-158" data-mp="z0119i03ehbh">
            Everything You Need to Organize Your AAC Planning Resources in One Place
          </p>
        </div>

        <div className="mt-8 overflow-hidden rounded-[28px] bg-white shadow-card" data-id="element-159" data-mp="2actp4hprilm9">
          <img src={images.hero} alt="Complete AAC Clinical Blueprint™ collection" className="block w-full bg-white" loading="lazy" data-id="element-160" data-mp="pjfjk8o60ji4" />

          <div className="px-5 pb-8 sm:px-8" data-id="element-161" data-mp="ul4w5sr1d58b">
            <h3 className="text-lg font-black text-ink" data-id="element-162" data-mp="zjg6s5p5njrl">Here’s what your collection includes:</h3>
            <ul className="mt-4 divide-y divide-navy/10" data-id="element-163" data-mp="13iyqwz95jqtd">
              {valueStack.map(item => <li key={item.label} className="flex items-start justify-between gap-4 py-3" data-id="element-164" data-mp="6use3p22ts40">
                  <span className="flex gap-2.5 text-[15px] font-semibold leading-snug text-ink" data-id="element-165" data-mp="btvm9idcseg7">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-success" strokeWidth={3} aria-hidden="true" data-id="element-166" data-mp="ftcswf4inhmy" />
                    {item.label}
                  </span>
                  <span className="shrink-0 text-[15px] font-bold text-muted" data-id="element-167" data-mp="3k8vqkgpyi87q">${item.value}</span>
                </li>)}
            </ul>
            <div className="mt-2 flex items-center justify-between gap-4 rounded-xl bg-cream px-4 py-3" data-id="element-168" data-mp="3o8o5db5y1alj">
              <span className="text-[15px] font-extrabold text-ink" data-id="element-169" data-mp="vdwbqmnu1inl">Total suggested reference value</span>
              <s className="text-xl font-black text-danger" data-id="element-170" data-mp="qejow1wyobl0">${total}</s>
            </div>

            <div className="mt-8 text-center" data-id="element-171" data-mp="154qxzr12wi91">
              <p className="text-sm font-black uppercase tracking-wide text-teal" data-id="element-172" data-mp="105xijt28eh68">Today’s price</p>
              <p className="mt-1 text-[22px] font-black text-ink" data-id="element-173" data-mp="cgcyf6ucddvd">
                JUST <span className="text-[72px] leading-none tracking-tight text-cta sm:text-[88px]" data-id="element-174" data-mp="cipok7a96uji">$27</span>
              </p>
              <p className="mt-2 text-[16px] text-muted" data-id="element-175" data-mp="li2p2ageg8s3">
                Get the complete collection for one payment of $27. No monthly membership is required.
              </p>
            </div>

            <div className="mt-6 flex items-start gap-3 rounded-2xl border border-teal/30 bg-teal-light p-4" data-id="element-176" data-mp="1wwgc5d3bwk72">
              <GlobeIcon className="mt-0.5 h-5 w-5 shrink-0 text-teal" aria-hidden="true" data-id="element-177" data-mp="1svwco2va94hr" />
              <p className="text-[15px] leading-snug text-ink" data-id="element-178" data-mp="20e4brtulkkq5">
                <strong data-id="element-179" data-mp="20gqeng6jmc21">Automatic currency conversion.</strong> The price is converted to your local currency automatically at checkout.
              </p>
            </div>

            <div className="mt-6" data-id="element-180" data-mp="1qi0xxqqduxnd">
              <div className="flex items-center justify-between gap-3" data-id="element-181" data-mp="1qiu52st97p61">
                <p className="flex items-center gap-1.5 text-[15px] font-extrabold text-danger" data-id="element-182" data-mp="1vft1ji0e487e">
                  <FlameIcon className="h-4 w-4" aria-hidden="true" data-id="element-183" data-mp="2j5x3lkxxjzwa" />
                  Only {SPOTS_LEFT} spots left at the promotional price
                </p>
                <span className="shrink-0 text-sm font-bold text-muted" data-id="element-184" data-mp="29g3t6n9ixqtm">{CLAIMED_PERCENT}%</span>
              </div>
              <div className="mt-2 h-4 w-full overflow-hidden rounded-full bg-navy/10" role="progressbar" aria-valuenow={CLAIMED_PERCENT} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-185" data-mp="2ed3z8y6ditkq">
                <div className="h-full rounded-full bg-danger" style={{
                width: `${CLAIMED_PERCENT}%`
              }} data-id="element-186" data-mp="1j7ph8jh5pynt" />
              </div>
            </div>

            <div className="mt-7" data-id="element-187" data-mp="197ovkqvtf6gg">
              <CtaButton label="Get instant access to AAC Clinical Blueprint™" data-id="element-188" data-mp="198ql20dkvvhp" />
            </div>
            <Countdown data-id="element-189" data-mp="14af7pfo2r2uq" />

            <p className="mt-4 text-center text-xs leading-relaxed text-muted sm:text-sm" data-id="element-190" data-mp="14b8bq8vnfe96">
              Digital product · [CONFIRM DELIVERY METHOD] · [CONFIRM REFUND POLICY BEFORE PUBLISHING]
            </p>
            <p className="mt-2 text-center text-xs italic text-muted" data-id="element-191" data-mp="1x05hjciobil1">
              Reference values are illustrative offer comparisons, not independently verified market prices.
            </p>
          </div>
        </div>
      </div>
    </section>;
}